import { CommonEnums } from '../common.enums';


export class Sch_Queue_Fldr {
    sch_Queue_Id: number;
    fldr_Id: number;
    reusableFlag: string;  //Read-Only
    fldr_Nm: string; //Read Only UI Purpose,using this Field to show folderName for GridObject while doing Select.
    nm: string;
    queue_Limit: number;

    constructor() {
        this.setDefaults();
    }

    setDefaults(): void {
        this.sch_Queue_Id = CommonEnums.defaults.LONG_VAL;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.fldr_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.queue_Limit = CommonEnums.defaults.LONG_VAL;
    }

    static parse(sch_Queue_FldrTmp: Sch_Queue_Fldr): Sch_Queue_Fldr {
        let sch_Queue_Fldr: Sch_Queue_Fldr = new Sch_Queue_Fldr();
        sch_Queue_Fldr.copyFrom(sch_Queue_FldrTmp);
        return sch_Queue_Fldr;
    }

    copy(): Sch_Queue_Fldr {
        let sch_Queue_FldrTmp: Sch_Queue_Fldr = new Sch_Queue_Fldr();

        sch_Queue_FldrTmp.sch_Queue_Id = this.sch_Queue_Id;
        sch_Queue_FldrTmp.fldr_Id = this.fldr_Id;
        sch_Queue_FldrTmp.reusableFlag = this.reusableFlag;
        sch_Queue_FldrTmp.fldr_Nm = this.fldr_Nm;
        sch_Queue_FldrTmp.nm = this.nm;
        sch_Queue_FldrTmp.queue_Limit = this.queue_Limit;

        return sch_Queue_FldrTmp;
    }

    copyFrom(sch_Queue_FldrTmp: Sch_Queue_Fldr): void {
        this.sch_Queue_Id = sch_Queue_FldrTmp.sch_Queue_Id;
        this.fldr_Id = sch_Queue_FldrTmp.fldr_Id;
        this.reusableFlag = sch_Queue_FldrTmp.reusableFlag;
        this.fldr_Nm = sch_Queue_FldrTmp.fldr_Nm;
        this.nm = sch_Queue_FldrTmp.nm;
        this.queue_Limit = sch_Queue_FldrTmp.queue_Limit;
    }

    compare(sch_Queue_FldrTmp: Sch_Queue_Fldr): string {
        let sch_Queue_FldrString: string = this.toString(false);
        let sch_Queue_FldrTmpString: string = sch_Queue_FldrTmp.toString(false);

        if (sch_Queue_FldrString != sch_Queue_FldrTmpString) {
            return sch_Queue_FldrString + ', ' + sch_Queue_FldrTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        return "Sch_Queue_Fldr [sch_Queue_Id=" + this.sch_Queue_Id + ", fldr_Id = " + this.fldr_Id +
            ", reusableFlag =" + this.reusableFlag + ", fldr_Nm = " + this.fldr_Nm +
            ", nm = " + this.nm + ", queue_Limit =" + this.queue_Limit + "]";
    }
}